<template>
  <v-container id="grv_riepilogo_ordine">
    <v-card
      color="#efefef"
      class="ma-0 mb-5 pa-6"
    >
      <v-row>
        <!-- {{ cliente }} -->
        <v-col>
          <v-simple-table
            class="bordered-table dense"
            width="100%"
          >
            <thead>
              <tr>
                <th>Cod. Cli.</th>
                <th>Cliente</th>
                <th class="text-no-wrap text-center">
                  Linea
                </th>
                <th class="text-no-wrap text-center">
                  Data Ordine
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-h2">
                  {{ order.codice }}
                </td>
                <td class="text-no-wrap pr-3">
                  {{ cliente.ragsoc }} {{ cliente.indiri_1 }}<br>
                  {{ cliente.indiri2 }} {{ cliente.locali }}
                </td>
                <td class="text-h2 text-center">
                  {{ $linea().label }}
                </td>
                <td class="text-h2 text-center">
                  {{ order.dataordine }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>

      <section
        class="STEP1"
        @dblclick="$emit('nextStep',1)"
      >
        <v-card
          width="100%"
          class="my-2 "
        >
          <v-col class="pa-6">
            <v-row>
              <v-btn
                dark
                icon
              >
                <v-icon
                  color="primary"
                  @click="$emit('nextStep',1)"
                >
                  mdi-circle-edit-outline
                </v-icon>
              </v-btn>
              <v-col cols="auto ">
                Riferimento Occhiale (n.Busta o Nome)<br>
                <span class="text-h2">{{ order.desrif }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </section>
      <section
        class="STEP2"
        @dblclick="$emit('nextStep',2)"
      >
        <template

          class="caratteristica_lenti"
        >
          <v-row>
            <v-col>
              <v-simple-table
                class="bordered-table dense"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>Lente</th>
                    <th>Tiplogia </th>
                    <!-- <th>Trattamento </th> -->
                    <th>Mod. Lente </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      class="text-h3"
                      width="100px"
                    >
                      OD
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_destip }}
                    </td>
                    <!-- <td class="text-no-wrap">
                      {{ order.lens.d_destrt }}
                    </td> -->
                    <td>
                      {{ order.lens?.grvlens?.dx?.itemcode }}
                      <br> <small class="font-weight-bold"> {{ order.lens?.grvlens?.dx?.linea }} {{ order.lens?.grvlens?.dx?.name }}</small><br>
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="text-h3"
                      width="100px"
                    >
                      OS
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_destip }}
                    </td>
                    <!-- <td class="text-no-wrap">
                      {{ order.lens.s_destrt }}
                    </td> -->
                    <td>
                      {{ order.lens?.grvlens?.sx?.itemcode }}
                      <br><small class="font-weight-bold"> {{ order.lens?.grvlens?.sx?.linea }} {{ order.lens?.grvlens?.sx?.name }}</small><br>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>

          <v-row>
            <!-- {{ caratteristiche  lenti }} -->
            <v-col>
              <v-simple-table
                class="bordered-table dense"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>Lente</th>
                    <th>SF</th>
                    <th>CYL</th>
                    <th class="text-center">
                      AX
                    </th>
                    <th>ADD</th>
                    <th>SD</th>
                    <th>ALT</th>
                    <th>PRISMA</th>
                    <th>GRADI</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="order.lens.d_filtro">
                    <td class="text-h3">
                      OD
                    </td>
                    <td class="font-weight-bold">
                      FILTRO per lente DX
                    </td>
                  </tr>
                  <tr v-else>
                    <td class="text-h3">
                      OD
                    </td>
                    <td class="text-no-wrap ">
                      {{ order.lens.d_vsfero }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_cilind }}
                    </td>
                    <td class="text-no-wrap text-center">
                      {{ order.lens.d_vlasse }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_addizi }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_semidi }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_altezz }}
                    </td>

                    <td class="text-no-wrap">
                      {{ order.lens.d_prisma }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.d_vgradi }}
                    </td>
                  </tr>

                  <tr v-if="order.lens.s_filtro">
                    <td class="text-h3">
                      OS
                    </td>
                    <td class="font-weight-bold">
                      FILTRO per lente SX
                    </td>
                  </tr>
                  <tr v-else>
                    <td class="text-h3">
                      OS
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_vsfero }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_cilind }}
                    </td>
                    <td class="text-no-wrap text-center">
                      {{ order.lens.s_vlasse }} &nbsp;&nbsp;
                      {{ order.lens.tabint }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_addizi }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_semidi }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_altezz }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_prisma }}
                    </td>
                    <td class="text-no-wrap">
                      {{ order.lens.s_vgradi }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </template>
        <v-row
          v-if="order.lens?.fornitura_lente?.value"
          class="ma-4 text-h3 text-no-wrap"
        >
          Fornire lenti: {{ order.lens?.fornitura_lente.title }}  <b v-if="order.lens?.fornitura_lente.value=='diametro'">&nbsp;Diametro: {{ order.lens?.diamet }}</b>
        </v-row>
      </section>

      <!-- {{ Montatura  }} -->
      <section
        v-if="order.model && order.model.length==1"
        class="STEP4"
        @dblclick="$emit('nextStep',4)"
      >
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>
                {{ (order.monsmo=='M' )?'Modello':'Sagoma' }}: {{ order.model[0].descrizione }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    class="px-8"
                  >
                    <table>
                      <tr><td>Marca:</td><td> {{ order.model[0].marca }}</td></tr>
                      <tr>
                        <td>Linea:</td>
                        <td> {{ order.model[0].linea }}</td>
                      </tr>
                      <tr>
                        <td>Mod.:</td>
                        <td> {{ order.model[0].modello }}</td>
                      </tr>
                      <tr>
                        <td>Colore:</td>
                        <td> {{ order.model[0].colore }}</td>
                      </tr>
                      <tr>
                        <td>Calibro:</td>
                        <td> {{ order.model[0].calibro }}</td>
                      </tr>
                      <tr>
                        <td>Ponte:</td>
                        <td> {{ order.model[0].ponte }}</td>
                      </tr>
                    </table>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                    class="px-8"
                  >
                    <table>
                      <tr>
                        <td>Asta:</td>
                        <td> {{ order.model[0].asta }}</td>
                      </tr>
                      <tr>
                        <td>Tipo_lente:</td>
                        <td> {{ order.model[0].tipo_lente }}</td>
                      </tr>
                      <tr>
                        <td>Materiale:</td>
                        <td> {{ order.model[0].materiale }}</td>
                      </tr>
                      <tr>
                        <td>Utente:</td>
                        <td> {{ order.model[0].utente }}</td>
                      </tr>
                      <tr>
                        <td>Cat. filtro:</td>
                        <td>{{ order.model[0].cat_filtro }}</td>
                      </tr>
                      <tr>
                        <td>Lente polarizzata:</td>
                        <td> {{ order.model[0].lente_polarizzata }}</td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-card>
              <v-card-title>
                Barcode
              </v-card-title>
              <v-card-text>
                Lente OD: {{ order.lens?.grvlens?.dx?.barcode }}<br>
                Lente OS: {{ order.lens?.grvlens?.sx?.barcode }}<br>
                {{ (order.monsmo=='M' )?'Montatura':'Sagomatura' }}:  {{ order.model[0].barcode }}<br>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </section>

      <!-- NOTE lavorazione -->
      <v-sheet class="mt-1">
        <v-row>
          <v-col
            cols="12"
            class="mx-2"
          >
            <p>Note lavorazione:</p>
            <ul>
              <li>{{ (order.monsmo=='M' )?'Occhiale Completo':'Solo Lenti Sagomate' }}</li>
              <li v-if="order.lens?.desmod=='NN'">
                Lente non in elenco: <b>{{ order.lens?.nolens_detail }}</b>
              </li>
            </ul>
          </v-col>
          <v-col
            cols="12"
          >
            <v-textarea
              v-model="steporder.noteord"
              counter
              class="mx-4"
              outlined
              label="Note Aggiuntive"
              auto-grow
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-card>
    <v-btn
      color="primary"
      @click="getPdf"
    >
      PDF
    </v-btn>
    <v-btn
      color="primary"
      @click="stdOrder"
    >
      Send
    </v-btn>
    <v-btn
      text

      @click="order.monsmo === 'M'? $emit('prevStep', step):$emit('prevStep', step - 1)"
    >
      Indietro
    </v-btn>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'
  // import { Printd } from 'printd'
  // import { get } from 'core-js/core/dict';

  export default {
    name: 'Riepilogo',
    props: {
      step: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        steporder: {},
        validForm: true,
        loading: false,
      }
    },
    computed: {
      ...mapState(['auth', 'order', 'carnet', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      rules () {
        return {
          required: value => !!value || 'Required.',
          min: v => (v && v.length >= 4) || 'Min 4 characters',
        }
      },

      cliente () {
        return this.clidata.anacli
      },
    },
    watch: {

    },
    mounted () {
      this.steporder = Object.assign({}, this.order)
      this.steporder.step = this.step
      this.steporder.dataordine = new Date().toLocaleDateString('it-IT')
      this.steporder.carnet = this.carnet
      this.$store.commit('setOrder', this.steporder)
      // console.error('Ricontrollare validità CarNum -- ma non ricordo cosa e perchè. 30.01.26 Dino')
    },
    destroyed () {

    },
    methods: {
      getPdf () {
        this.$store.commit('setOrder', this.steporder)
        console.log('order', this.order)
        this.loading = true
        engine.getPdf(this.steporder)
          .then(result => {
            if (result) {
              // (C2) TO "FORCE DOWNLOAD"
              var url = window.URL.createObjectURL(result)
              var anchor = document.createElement('a')
              anchor.href = url
              anchor.target = '_blank'
              // anchor.download = obj.filename || `${this.page}.pdf`
              anchor.click()
              // // (C3) CLEAN UP
              // window.URL.revokeObjectURL(url)
              // document.removeChild(anchor)
            }
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
            }
            // this.$store.commit('setSnack', { message: 'PDF ok', color: '#4caf50' })
          })
          .catch((errore) => {
            console.log('api err: ', errore)
          }).finally(() => { this.loading = false })
      },
      stdOrder () {
        this.$store.commit('setOrder', this.steporder)
        console.log('order_swf', this.order)
        this.$emit('stdOrder')
      },
    },
  }
</script>
<style>
#riepilogo_ordine .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: transparent !important; /* remove on hover effect */
}

#riepilogo_ordine .v-data-table th{
  font-size: 1.3rem;
}
@media print {
  #riepilogo_ordine {
    transform: scale(0.9);
    transform-origin: top left;
  }
}
</style>
